import { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import api, { API } from "../lib/api";
import { TEXT_DEFAULTS } from "../lib/constants";

const SettingsContext = createContext(null);

const FALLBACK = { app_name: "OrtoFrutta", slogan: "Manager", primary_color: "160 84% 39%", logo_file_id: null, login_bg_file_id: null, texts: {} };

// Consente solo caratteri validi per una tripletta colore HSL ("160 84% 39%"): evita injection nel tag <style>.
const safeColor = (c) => (typeof c === "string" && /^[0-9%.\s]+$/.test(c) ? c : FALLBACK.primary_color);

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(FALLBACK);

  const load = useCallback(
    () => api.get("/settings").then((r) => setSettings(r.data)).catch(() => setSettings(FALLBACK)),
    []
  );

  useEffect(() => { load(); }, [load]);

  useEffect(() => {
    const color = safeColor(settings?.primary_color);
    let el = document.getElementById("brand-vars");
    if (!el) {
      el = document.createElement("style");
      el.id = "brand-vars";
      document.head.appendChild(el);
    }
    // textContent (non innerHTML): il contenuto non viene interpretato come HTML.
    el.textContent = `.dark{--primary:${color} !important;--ring:${color} !important;}`;
  }, [settings]);

  const text = useCallback(
    (key) => {
      const v = settings?.texts?.[key];
      return v === undefined || v === null || v === "" ? (TEXT_DEFAULTS[key] ?? "") : v;
    },
    [settings]
  );

  const value = useMemo(() => ({ settings, reload: load, text }), [settings, load, text]);

  return <SettingsContext.Provider value={value}>{children}</SettingsContext.Provider>;
}

export const useSettings = () => useContext(SettingsContext);

export function settingsImageUrl(field, settings) {
  if (!settings?.[field]) return null;
  return `${API}/settings/image/${field}?v=${encodeURIComponent(settings.updated_at || "")}`;
}
